import { StyledMarkdownOrText } from '@components';
import Text from '@components/Text/Text';
import { BreakingText } from '@components/Text/TruncatedText';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { useSelector } from 'react-redux';
import {
  Container,
  DescriptionContainer,
  Divider,
  Text as MarkdownText,
} from './UpdateDescription.styles';

interface IUpdateDescription {
  description: string;
  originalMessage: string;
}

const UpdateDescription = ({
  description,
  originalMessage,
}: IUpdateDescription) => {
  const { isMobile } = useSelector(checkDevice());
  return (
    <Container>
      {originalMessage && (
        <>
          <Text text={isMobile ? 'h300' : 'h400'} mb={16}>
            Original Message
          </Text>
          <BreakingText
            underline
            component="a"
            text="p100"
            textColor="b401"
            href={originalMessage}
            target="_blank"
            rel="noreferrer noopener"
          >
            {originalMessage}
          </BreakingText>
        </>
      )}

      {originalMessage && description && <Divider height="24px" />}

      {description && (
        <>
          <Text text={isMobile ? 'h300' : 'h400'} mb={16}>
            Update Description
          </Text>
          <DescriptionContainer>
            <StyledMarkdownOrText description={description}>
              <MarkdownText className="description">{description}</MarkdownText>
            </StyledMarkdownOrText>
          </DescriptionContainer>
        </>
      )}
    </Container>
  );
};

export { UpdateDescription };
